<template>
  <a-card :bordered='false'>
    <a-form ref='form' :model='search' :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
      <a-form-item label="解除二维码" name='keyword'>
        <a-input style="width: 270px" v-model:value="search.keyword" placeholder="请输入二维码进行搜索" />
      </a-form-item>
      <a-form-item label="操作时间" name='time'>
        <a-range-picker v-model:value="time" valueFormat='YYYY-MM-DD ' format='YYYY-MM-DD' @change="changTime" />
      </a-form-item>
      <a-form-item>
        <a-button type="primary" htmlType='submit'>搜索</a-button>
      </a-form-item>
    </a-form>
    <a-table class='m-t-20' :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='data'>
      <template v-slot:code_type="{ record }">
        <p v-if='record.code_type == 1'>大标</p>
        <p v-if='record.code_type == 2'>中标</p>
        <p v-if='record.code_type == 3'>小标</p>
      </template>
    </a-table>
    <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper
      :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange"
      @showSizeChange="pageSizeChange"  :show-total="total => `总数: ${total} `"/>
  </a-card>
</template>
<script>
  import { reactive, ref, toRefs, onMounted, inject } from "vue";
  import { iscode } from "@/utils/app";
  import { message } from "ant-design-vue";
  import { getDissolve} from '@/api/antiFleeing';
  const def = {
    page: 1,
    limit: 10,
    keyword: "",
    start_time: "",
    end_time: ""
  };
  export default {
    setup() {
      const search = ref({ ...def });
      const state = reactive({
        time: [],
        listLoading: false,
        total: 0,
      });
      let data = ref();
      let columns = [
        {
          title: "解除二维码",
          dataIndex: "code_sn",
          key: "product_name",
        },
        {
          title: "二维码类型",
          dataIndex: "code_type",
          key: "code_type",
          slots: { customRender: "code_type" }
        },
        {
          title: "操作者",
          dataIndex: "create_role_name",
          key: "create_role_name",
        },
        {
          title: "操作时间",
          dataIndex: "create_time",
          key: "create_time",
          width:200
        },
      ];
      // 页面筛选项搜索
      const pageSearchChange = () => {
        search.value = { ...search.value, page: 1 };
        initData(search.value);
      };
      // 分页当前页切换
      const pageCurrentChange = (page, pageSize) => {
        search.value.page = page;
        initData(search.value);
      };
      // 分页当前页显示多少条切换
      const pageSizeChange = (current, limit) => {
        search.value.page = 1;
        search.value.limit = limit;
        initData(search.value);
      };
      //获取列表
      const initData = async (values) => {
        state.listLoading = true;
        let res = await getDissolve(values).then((res) => res.data);
        state.listLoading = false;
        if (iscode(res)) {
          data.value = res.data;
          state.total = res.meta.total;
        }else {
          message.error(res.msg);
        }
        state.listLoading = false;
      };

      const changTime = (e) => {
        search.value.start_time = e[0];
        search.value.end_time = e[1];
      };
      onMounted(() => {
        initData(search.value);
      });
      return {
        ...toRefs(state),
        search,
        data,
        columns,
        pageSearchChange,
        pageCurrentChange,
        pageSizeChange,
        changTime,
      };
    },
  };
</script>